<template>
	<ActivityDetailSection :title="content.sectionTitle">
		<ActivityResourceCard>
			<ActivityLinkTypeIcon :link-type="linkType" />
			<ActivityResourceSummary :title="title" :summary="summary" />
			<Button v-if="buttonEnabled" class="action-button" variant="primary" size="m" shape="pill" @click="$emit('open')">
				{{ content.actionLabel }}
			</Button>
		</ActivityResourceCard>
	</ActivityDetailSection>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import ActivityDetailSection from "@/components/activity/ActivityDetailSection.vue"
import ActivityLinkTypeIcon from "@/components/activity/ActivityLinkTypeIcon.vue"
import ActivityResourceCard from "@/components/activity/ActivityResourceCard.vue"
import ActivityResourceSummary from "@/components/activity/ActivityResourceSummary.vue"
import Button from "@/components/ui/Button.vue"
import { LinkType } from "@/types/activity"

const props = withDefaults(
	defineProps<{
		linkType: LinkType
		title: string
		summary?: string | null
		buttonEnabled?: boolean
	}>(),
	{
		summary: null,
		buttonEnabled: true,
	}
)

defineEmits<{
	open: []
}>()

const { t } = useI18n()

const content = computed(() => {
	if (props.linkType === LinkType.PROJECT) {
		return {
			sectionTitle: t("activityPage.details.linkedProject"),
			actionLabel: t("activityPage.details.openProject"),
		}
	}

	return {
		sectionTitle: t("activityPage.details.linkedSavedSearch"),
		actionLabel: t("activityPage.details.viewSearch"),
	}
})
</script>

<style scoped>
.action-button {
	min-width: auto;
}
</style>
